import { render, staticRenderFns } from "./SubdomainHistory.vue?vue&type=template&id=71799ff6"
import script from "./SubdomainHistory.vue?vue&type=script&lang=js"
export * from "./SubdomainHistory.vue?vue&type=script&lang=js"
import style0 from "./SubdomainHistory.vue?vue&type=style&index=0&id=71799ff6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports